// extracted by mini-css-extract-plugin
module.exports = {"header":"styles_header__lOZtK","container":"styles_container__2RmlN","title":"styles_title__3FXru","wrapper":"styles_wrapper__akV1r","answer":"styles_answer__1VKLi"};